import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-location',
  templateUrl: './icon-location.component.html',
  styleUrls: ['./icon-location.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconLocationComponent {}
